import locationService from '../../../../services/notisphere/location'
import LocationModal from '../LocationModal'
import { AG_GridCustomizedTableHeaders_Key, txtFormatter, trimWhiteSpaces, DateComparator } from '../../../../misc/tableHeaders'
import { OUTPUT_SHORTDATE_FORMAT } from '../../../../misc/commons'
import { _findObj, toLocal, notisphereLocationVerificationActionRenderCell } from '../../../../misc/genericFunctions'
import HeaderCheckBox from '../../../../components/noti/TableGrid/CustomComponent/headerCheckBox.vue'


export default {
    props: {
        providerOrgId: { type: Number, default: null }
    },
    components: {
        LocationModal,
        HeaderCheckBox
    },
    data() {
        return {
            total: 0,
            items: [],
            userIds: [],
            Listitems: [],
            centralizedsetting: false,
            search: {
                supplier_id: null,
                state: null,
                city: null,
                verified: null,
                notcovered: null,
                supplieraddress1: null,
                suppliercity: null,
                supplierstate: null,
                supplierzipcode: null,
                status: null,
                suporgname: null,
                locationid: null,
                locationname: null
            },
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            verifyLocation: [],
            terms: false,
            showE: false,
            showV: true,
            isEnable: false,
            locationModalKey: 0,
            listSupplier: [],
            listCity: [],
            listState: [],
            listStatus: [{ text: 'NotiSphere', value: 'NotiSphere' },{ text: 'Invalid', value: 'Invalid' },
                { text: 'External', value: 'External' }, { text: 'Pending', value: 'Pending' }],
            CentralizedDataStatus: [{ text: 'Emailed', value: 'Emailed' },{ text: 'Invalid', value: 'Invalid' },
                { text: 'External', value: 'External' }, { text: 'Pending', value: 'Pending' }],
            columnDefs: [],
            gridOptions: {
                rowSelection: 'multiple',
                rowModelType: 'serverSide',
                suppressRowClickSelection: true,
                enableRangeSelection: true,
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                onSelectionChanged: this.onSelectionChanged,
                getContextMenuItems: this.getContextMenuItems,
                context: {
                    updateLocation: this.updateLocation
                }
            },
            rowModelType: 'serverSide',
            defaultColDef: {
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
            },
            rowData: [],
            gridApi: null,
            columnApi: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            frameworkComponents: {
                HeaderCheckBox: HeaderCheckBox
            }
        }

    },
    beforeMount() {
        this.initializeColumns()
    },
    mounted() {
        this.getSearchMeta()
    },
    computed: {
        getlistdata(){
            return this.centralizedsetting == true ? this.CentralizedDataStatus : this.listStatus
        }
    },
    methods: {
        initializeColumns() {
            this.columnDefs = [
                {  minWidth: 60, field: 'multichoice', type: 'rightColumn', hide: false, headerName: '', suppressMenu: true, suppressSorting: true, editable: true,suppressColumnsToolPanel: true,
                    headerComponent: 'HeaderCheckBox', HeaderChangeCallback: this.headerChangeCallback, suppressMovable: true,
                    checkboxSelection: function (params) {  return params.columnApi.getRowGroupColumns().length === 0},
                    headerCheckboxSelection: function (params) { return params.columnApi.getRowGroupColumns().length === 0},
                },
                { minWidth: 150, field: 'supplier_org_name', filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces}, hide: false, headerName: 'Supplier', sortable: true, filter: 'agTextColumnFilter', menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'] },
                { minWidth: 120, field: 'location_id', filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces}, hide: false, headerName: 'Location Id', sortable: true, filter: 'agTextColumnFilter', menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'] },
                { minWidth: 150, field: 'location_name', filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces}, hide: false, headerName: 'Location Name', sortable: true, filter: 'agTextColumnFilter', menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'] },
                {
                    minWidth: 200, field: 'address1', filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces}, hide: false, headerName: 'Address', sortable: true, filter: 'agTextColumnFilter', menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'], cellRenderer: (params) => {
                        let address = ''
                        if (params.data.address1) address += params.data.address1
                        if (params.data.address2) address += `<br/><span class="small">${params.data.address2}</span>`
                        if (params.data.city) address += `<br/><span class="small">${params.data.city}</span>`
                        if (params.data.state || params.data.zip_code) address += `<br/><span class="small">${params.data.state || ''} ${params.data.zip_code || ''}</span>`
                        return address
                    }
                },
                {
                    minWidth: 80, field: 'status', type: 'centerColumn', filterParams: {
                        values: this.getlistdata.map(status => status.value),
                        valueFormatter: (params) => {
                            const statusMap = {
                                'NotiSphere': 'NotiSphere',
                                'Invalid': 'Invalid',
                                'External': 'External',
                                'Pending': 'Pending',
                                'Emailed': 'Emailed'
                            }
                            return statusMap[params.value] || params.value
                        }
                    }, hide: false, headerName: 'Status', sortable: true, filter: 'agSetColumnFilter', menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'], cellRenderer: (params) => {
                        let img = null
                        if (params.data.verified) {
                            img = require('@/assets/img/Notisphere_Icon_Crescent_Mono_Dark.svg')
                        }
                        else if (params.data.emailed) {
                            img = require('@/assets/img/at-svg.svg')
                        }
                        else if (params.data.notcovered) {
                            img = require('@/assets/img/icon-mail.svg')
                        }
                        else if (params.data.invalid) {
                            img = require('@/assets/img/close-icon.svg')
                        }
                        return img ? `<img src=${img} width="16px" alt="" />` : ''
                    }
                },
                {
                    minWidth: 150,
                    field: 'last_change_by',
                    filterParams: { textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces },
                    hide: false,
                    headerName: 'Last Modified by',
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
                },
                {
                    minWidth: 160,
                    field: 'last_change_at',
                    hide: false,
                    headerName: 'Last Update',
                    sortable: true,
                    filter: 'agDateColumnFilter',
                    menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
                    filterParams: {
                        browserDatePicker: true,
                        minValidYear: 2010,
                        maxValidYear: 2030,
                        filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'inRange', 'blank', 'notBlank', 'empty'],
                        defaultOption: 'equals',
                        comparator: DateComparator
                    },
                    cellRenderer: (params) => {
                        if (params.value == null || params.value == undefined || params.value == '')
                            return 'NA'
                        var dateTime = toLocal(params.value, { inputFormat: 'YYYY-MM-DDTHH:mm:ss', outputFormat: OUTPUT_SHORTDATE_FORMAT })
                        return dateTime
                    }
                },
                {
                    minWidth: 80, field: 'action', type: 'centerColumn', hide: false, headerName: 'Actions', sortable: false, filter: false, suppressMenu: true, suppressColumnsToolPanel: true, cellRenderer: (params) => {
                        let eGui = notisphereLocationVerificationActionRenderCell(params)
                        // Add click event listener for the edit action
                        eGui.addEventListener('click', (e) => {
                            if (e.target.closest('[data-action="edit"]')) {
                                // Find the parent component instance
                                const context = params.context
                                if (context && context.updateLocation) {
                                    context.updateLocation(params.data)
                                }
                            }
                        })
                        return eGui
                    }
                }
            ]
        },
        headerChangeCallback(checkedAll) {
            this.gridApi.forEachNode((node) => node.setSelected(checkedAll))
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login = this.table_Connection_Data.Notisphere_Login || {}
            this.table_Connection_Data.Notisphere_Login.LocationVerification_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.LocationVerification_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Notisphere_Login = this.table_Connection_Data.Notisphere_Login || {}
            this.table_Connection_Data.Notisphere_Login.LocationVerification_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.LocationVerification_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        applyFilters() {
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        onSelectionChanged(params) {
            if (params.api.getSelectedRows().length > 0 && !this.isEnable) {
                this.$refs.locationModal.$el.parentElement.children[0].children[0].children[0].children[1].children.disVal.click()
                this.isEnable = true
            }
            if (params.api.getSelectedRows().length == 0 && this.isEnable) {
                this.$refs.locationModal.$el.parentElement.children[0].children[0].children[0].children[1].children.disVal.click()
                this.isEnable = false
            }
        },
        resetHeaderCheckbox(){
            document.getElementById('headerSelectAllcheckbox')?.checked && (document.getElementById('headerSelectAllcheckbox').checked = false)
            this.gridApi.deselectAll()
            this.Listitems = []
            this.verifyLocation = []
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        getSearchMeta() {
            locationService.pro_getSearchMeta(this.providerOrgId).then(resp => {
                if (!resp.error) {
                    var data = resp.data.d
                    this.listSupplier = [
                        ...data.supplier
                    ]
                    this.listCity = [
                        ...data.city.map(x => { return { text: x, value: x } })
                    ]
                    this.listState = [
                        ...data.state.map(x => { return { text: x, value: x } })
                    ]
                }
            })
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi})
        },
        DisableChange: function () {
            return !this.terms
        },
        addMoreClick() {
            this.locationModalKey += 1
            this.$nextTick(() => {
                this.$refs.locationModal.forceRerenderInsert()
            })
        },
        updateLocation(payload) {
            this.locationModalKey += 1
            this.$nextTick(() => {
                this.$refs.locationModal.forceRerenderUpdate(payload)
            })
        },


        VerifyAllChange() {
            this.verifyLocation = []
            this.gridApi?.getSelectedRows()?.forEach(item => {
                this.verifyLocation.push({site_id: item.site_id,supplier_add1: item.address1,supplier_add2: item.address2,supplier_city: item.city,supplier_state: item.state,supplier_zip_code: item.zip_code, supplier_org_id: item.supplier_org_id, location_id: item.location_id, verify: true, invalid: false , notcovered: false})
            })
            this.verifyLocation.forEach(item => {
                item.verify = true
                item.invalid = false
                item.notcovered = false
            })
            this.updateVerifyLocation()
            this.resetHeaderCheckbox()
        },
        EmailedAllChange() {
            this.verifyLocation = []
            this.gridApi?.getSelectedRows()?.forEach(item => {
                this.verifyLocation.push({site_id: item.site_id,supplier_add1: item.address1,supplier_add2: item.address2,supplier_city: item.city,supplier_state: item.state,supplier_zip_code: item.zip_code, supplier_org_id: item.supplier_org_id, location_id: item.location_id, verify: false, emailed: true, invalid: false , notcovered: false})
            })
            this.verifyLocation.forEach(item => {
                item.emailed = true
                item.verify = false
                item.invalid = false
                item.notcovered = false
            })
            this.updateVerifyLocation()
            this.resetHeaderCheckbox()
        },

        NotCoveredAllChange() {
            this.verifyLocation = []
            this.gridApi?.getSelectedRows()?.forEach(item => {
                this.verifyLocation.push({site_id: item.site_id, supplier_add1: item.address1,supplier_add2: item.address2,supplier_city: item.city,supplier_state: item.state,supplier_zip_code: item.zip_code,supplier_org_id: item.supplier_org_id, location_id: item.location_id, verify: false, invalid: false, notcovered: true })
            })
            this.verifyLocation.forEach(item => {
                item.verify= false
                item.invalid= false
                item.notcovered = true
            })
            this.updateVerifyLocation()
            this.resetHeaderCheckbox()
        },
        InvalidAllChange() {
            this.verifyLocation = []
            this.gridApi?.getSelectedRows()?.forEach(item => {
                this.verifyLocation.push({site_id: item.site_id,supplier_add1: item.address1,supplier_add2: item.address2,supplier_city: item.city,supplier_state: item.state,supplier_zip_code: item.zip_code, supplier_org_id: item.supplier_org_id, location_id: item.location_id, verify: false, invalid: true , notcovered: false})
            })
            this.verifyLocation.forEach(item => {
                item.invalid = true
                item.verify = false
                item.notcovered = false
            })
            this.updateVerifyLocation()
            this.resetHeaderCheckbox()
        },
        getCentralizedSettingData(){
            locationService.getCentralizedIntakeData(this.providerOrgId).then( resp =>{
                this.centralizedsetting = resp.data.data
                if(this.centralizedsetting == true){
                    this.showE = true
                    this.showV = false
                }
                // Reinitialize columns with updated status filter options
                this.initializeColumns()
                // Update the grid with new column definitions if grid is already initialized
                if (this.gridApi && this.columnApi) {
                    this.columnApi.setColumnDefs(this.columnDefs)
                }
            })
        },
        fetchDelay() {
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        getContextMenuItems(params) {
            document.getElementById('headerSelectAllcheckbox')?.checked && (document.getElementById('headerSelectAllcheckbox').checked = false)
            params.api.deselectAll()
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.filterModel = that.gridApi.getFilterModel()
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        search: that.searchQuery.globalSearch,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        email: email,
                    }
                    const resp = await locationService.downloadAgGridNotiLocationVerificationXLSX(query_param, that.providerOrgId)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        fetchData(params) {
            document.getElementById('headerSelectAllcheckbox')?.checked && (document.getElementById('headerSelectAllcheckbox').checked = false)
            params?.api?.deselectAll()
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params?.api
            that.columnApi = params?.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    // Handle filters from AG Grid
                    const filterModel = params.request?.filterModel || {}
                    that.search.filterModel = that.gridApi.getFilterModel()
                    locationService.pro_findLocation({
                        ...that.searchQuery,
                        search: that.searchQuery.globalSearch,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search
                    }, that.providerOrgId).then(resp => {
                        if (!resp.error) {
                            const recallsarray = resp.data.d.c
                            that.total = resp.data.d.t
                            that.items = recallsarray
                            that.getCentralizedSettingData()
                            if(that.total == 0){
                                that.gridApi?.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi?.hideOverlay()
                            }
                            return recallsarray
                        }
                    }).then(response => {
                        params.successCallback(response)
                    })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            // register datasource with the grid
            params?.api?.setServerSideDatasource(datasource)
        },
        updateVerifyLocation() {
            locationService.pro_updateVerifyLocation(this.verifyLocation, this.providerOrgId).then(resp => {
                if (!resp.error) {
                    this.verifyLocation = []
                    this.onCompleted('UPDATE')
                }
            })
        },
        onGlobalSearchChange(searchValue) {
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
    }
}